import * as React from "react";
import { tokens } from "../../theme";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Typography, useTheme } from "@mui/material";
import LoginFieldBox from "./components/LoginFieldBox";

export default function SignInSide() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    // <ThemeProvider theme={theme}>
    // {/* Main Container - Body */}
    <Grid container component="main" sx={{ height: "100vh", width: "125% !important", position: "absolute", left: "-25%"}}>
      {/* BG */}
      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItems="center"
        xs={12}
        sx={{
          backgroundImage: "url(/assets/login/Login-BG-2.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
        // spacing={10}
      >
        <Grid
          container
          direction={"row"}
          p={3}
          justifyContent="space-around"
          alignItems={"center"}
        >
          <Grid item xs={12} sm={5} md={4} lg={5} xl={6} pb={5} >
            <Box display="flex" alignItems="center">
              <img src="assets/common/Logo-White.svg" width={320} />
            </Box>
          </Grid>

          {/* Login Container */}
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            lg={5}
            xl={6}
            component={Paper}
            elevation={12}
            sx={{
              borderRadius: 3,
              border: "1px solid #E4EBF7",
              padding: "0"
            }}
          >
            {/* Header */}
            <Box
              sx={{
                py: 6,
                px: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                color={colors.grey[100]}
                fontWeight="bold"
                sx={{ m: "0 0 15px 0px", fontSize: 24 }}
              >
                Log in to Account
              </Typography>

              {/* Form Elements */}
              <Box sx={{ padding: "0 5%" }}>
                <LoginFieldBox />
              </Box>
              {/* Form Elements */}
              
            </Box>
            {/* Header */}
          </Grid>
          {/* Login Container */}

          <Box sx={{ position:"absolute", bottom:"0", right:"2%"}}>
          <Typography
                variant="h5"
                color={colors.grey[900]}
                fontWeight="400"
                sx={{ m: "0 0 15px 0px", fontSize: 16 }}
              >
                2024 © YTLC. All Rights Reserved.
              </Typography>
          </Box>
          


        </Grid>
      </Grid>
      {/* BG */}
    </Grid>
    // {/* Main Container - BG */}
    // </ThemeProvider>
  );
}
